import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const CartContext = createContext(null);
const KEY = "jd_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const add = useCallback((product, qty = 1) => {
    setItems((prev) => {
      const ex = prev.find((i) => i.product_id === product.id);
      if (ex) return prev.map((i) => i.product_id === product.id ? { ...i, qty: i.qty + qty } : i);
      return [...prev, {
        product_id: product.id, slug: product.slug,
        name_de: product.name_de, name_en: product.name_en,
        price: product.price, sale_price: product.sale_price || null,
        vat_rate: product.vat_rate, type: product.type,
        image: (product.images || [])[0] || null, qty,
      }];
    });
  }, []);

  const setQty = useCallback((pid, qty) => {
    setItems((prev) => prev.map((i) => i.product_id === pid ? { ...i, qty: Math.max(1, qty) } : i));
  }, []);
  const remove = useCallback((pid) => setItems((prev) => prev.filter((i) => i.product_id !== pid)), []);
  const clear = useCallback(() => setItems([]), []);

  const count = items.reduce((s, i) => s + i.qty, 0);
  const unit = (i) => Number(i.sale_price || i.price || 0);
  const subtotal = items.reduce((s, i) => s + unit(i) * i.qty, 0);
  const tax = 0; // Kleinunternehmer: ignore legacy VAT rates in saved carts.
  const total = subtotal + tax;

  return (
    <CartContext.Provider value={{ items, add, setQty, remove, clear, count, subtotal, tax, total }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
